/* RESPONSIBLE TEAM: team-workflows */
import type AppService from 'embercom/services/app-service';
import { fragment } from 'ember-data-model-fragments/attributes';
import Step from 'embercom/models/operator/visual-builder/step';
import { buildValidations, validator } from 'ember-cp-validations';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { inject as service } from '@ember/service';
import { VALID_PLATFORM_ICONS } from 'embercom/objects/standalone/constants';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class SetConversationDataAttribute extends Step.extend(Validations) {
  @service declare appService: AppService;
  @service declare attributeService: any;
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.setConversationDataAttribute;
  }

  get conversationDataAttribute() {
    return this.attributeService.nonArchivedNonSystemDefinedConversationCustomAttributes.findBy(
      'identifier',
      this.action.get('actionData.attribute_identifier'),
    );
  }

  get stepIcon() {
    if (
      this.appService.app.hasStandaloneSetting &&
      VALID_PLATFORM_ICONS.includes(this.conversationDataAttribute?.icon)
    ) {
      return this.conversationDataAttribute.icon;
    }

    return 'conversation';
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'conversation_attributes';
  }

  static createNewStep(
    store: Store,
    params: { attributeIdentifier: string },
  ): SetConversationDataAttribute {
    return store.createRecord('operator/visual-builder/step/set-conversation-data-attribute', {
      type: 'operator/visual-builder/step/set-conversation-data-attribute',
      action: store.createFragment('rules/rule-action', {
        type: 'set-conversation-data-attribute',
        justAdded: true,
        actionData: {
          attribute_identifier: params.attributeIdentifier,
        },
      }),
    });
  }
}
